import { useState } from "react";
import axios from "axios";
import { Bell, Check, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const SeriesSubscribe = ({ slug, series, compact = false }) => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const [msg, setMsg] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setState("busy");
    try {
      const r = await axios.post(`${API}/series/${slug}/subscribe`, { email: email.trim() });
      setState("done");
      setMsg(r.data.already ? "You're already on the list — we'll hit your inbox when the next session drops." : "You're in. The next session lands in your inbox the moment it drops.");
    } catch (err) {
      setState("error");
      setMsg(err.response?.data?.detail || "Something went wrong — try again.");
    }
  };

  return (
    <div data-testid="series-subscribe" className={`border border-white/10 bg-[#070707] ${compact ? "p-5" : "p-6 md:p-8"}`}>
      <p className="inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.3em] font-bold text-[#E30613]"><Bell size={12} /> Never miss a session</p>
      <p className={`text-white font-bold leading-snug mt-2 ${compact ? "text-base" : "text-lg md:text-xl"}`}>Get an email the moment a new {series} drops.</p>
      {state === "done" ? (
        <p data-testid="series-subscribe-success" className="mt-4 inline-flex items-start gap-2 text-sm text-emerald-400"><Check size={16} className="mt-0.5 shrink-0" /> {msg}</p>
      ) : (
        <form onSubmit={submit} className="mt-4 flex flex-col sm:flex-row gap-2" data-testid="series-subscribe-form">
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@email.com"
            data-testid="series-subscribe-email"
            className="flex-1 bg-black border border-white/20 focus:border-[#E30613] outline-none text-white text-sm px-4 py-3 placeholder:text-neutral-600"
          />
          <button type="submit" disabled={state === "busy"} data-testid="series-subscribe-submit"
            className="inline-flex items-center justify-center gap-2 bg-[#E30613] text-white text-xs uppercase tracking-[0.25em] font-bold px-6 py-3 hover:bg-white hover:text-black transition-colors disabled:opacity-60">
            {state === "busy" ? <Loader2 size={14} className="animate-spin" /> : null} Subscribe
          </button>
        </form>
      )}
      {state === "error" && <p data-testid="series-subscribe-error" className="mt-2 text-xs text-red-400">{msg}</p>}
      {state !== "done" && <p className="mt-3 text-[11px] text-neutral-600">One email per new session. Unsubscribe anytime.</p>}
    </div>
  );
};
